import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Table from '../../../../components/Table/Table'
import {
    formatServiceHistoryRows,
    serviceHistoryCols,
    serviceHistoryColsMobile,
} from '../../../../helpers/tableUtils'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import useFilterModal from '../../../../hooks/useFilterModal'
import useScreen from '../../../../hooks/useScreen'
import { getInitialFilters } from '../../../../helpers/serviceHistoryFilters'

const ServiceHistory = ({ requests, loadServices, assetInfo }) => {
    const [allRequests, setAllRequests] = useState(requests)
    const [filterOpen, setFilterOpen] = useState(false)
    const [initialFilters, setInitialFilters] = useState([])

    useEffect(() => {
        if (requests?.length > 0) {
            setInitialFilters(getInitialFilters(requests))
        }
    }, [requests])

    const {
        onFilter,
        filteredData: filteredRequests,
        setFilteredData: setFilteredRequests,
    } = useFilterModal(formatServiceHistoryRows, allRequests)
    const { isMobile } = useScreen()

    const hasFilterByName =
        requests?.length > 0
            ? initialFilters?.find(item => {
                  return item?.field === 'userName' && item?.filters?.length > 0
              })
            : true

    useEffect(() => {
        if (
            loadServices &&
            requests?.length === 0 &&
            assetInfo?.salesforceID != null
        ) {
            loadServices()
        }
    }, [assetInfo])

    useEffect(() => {
        if (allRequests?.length > 0) {
            setFilteredRequests(formatServiceHistoryRows(allRequests))
        }
        return () => {
            setFilteredRequests([])
        }
    }, [allRequests])

    useEffect(() => {
        setAllRequests(requests)
    }, [requests])

    const colsOrderMobile = isMobile
        ? serviceHistoryColsMobile
        : serviceHistoryCols

    const renderTable = useCallback(() => {
        return (
            <Table
                selectable={false}
                hasSearch={true}
                columns={colsOrderMobile}
                data={filteredRequests}
                totalResults={requests?.length}
                type="scroll"
                headerTitle="Requests Details"
                searchPlaceholder="Search Request"
                actions={[
                    hasFilterByName != null && (
                        <FilterModal
                            isSmallScreen
                            key="filterModal"
                            filtersGroup={initialFilters}
                            open={filterOpen}
                            setOpen={setFilterOpen}
                            onFilter={onFilter}
                            data={filteredRequests}
                        />
                    ),
                ]}
                searchFields={[
                    'name',
                    'type',
                    'statusKey',
                    'statusDescription',
                    'prettyDate',
                    'submittedBy',
                    'details',
                    'requestNumber',
                ]}
                hasActiveFilters={true}
            />
        )
    }, [allRequests, filterOpen, filteredRequests])

    return renderTable()
}

ServiceHistory.propTypes = {
    requests: PropTypes.array,
    loadServices: PropTypes.func.isRequired,
    assetInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
}

export default ServiceHistory
